import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { ImpersonationHeaderIcon } from "features/Impersonation/components/ImpersonationHeaderIcon";
import type { ReactNode } from "react";
import { BrandLogo } from "../BrandLogo";
import { UserMenu } from "../UserMenu/UserMenu";

function UnauthorizedLayoutHeader() {
  const { isDesktop } = useBreakpoints();
  return (
    <Box
      component="header"
      sx={{ flexGrow: 1, boxShadow: (theme) => theme.shadows[1], zIndex: 1 }}
    >
      <AppBar position="static" component="section">
        <Toolbar
          disableGutters
          sx={{ px: 3, justifyContent: "space-between", gap: 3 }}
        >
          <Box pt={1} maxWidth={175}>
            {!isDesktop && <BrandLogo />}
          </Box>
          <Stack direction="row" alignItems="center" spacing={2}>
            <ImpersonationHeaderIcon />
            <UserMenu menuItems={["logout"]} />
          </Stack>
        </Toolbar>
      </AppBar>
      {isDesktop && (
        <Stack
          component="nav"
          direction="row"
          alignItems="center"
          px={6}
          spacing={3}
          bgcolor="background.paper"
          maxWidth="100vw"
        >
          <Box width={200} py={1}>
            <BrandLogo />
          </Box>
        </Stack>
      )}
    </Box>
  );
}

export function UnauthorizedLayout({ children }: { children: ReactNode }) {
  return (
    <Box flex={1} display="grid" height="100vh" gridTemplateRows="auto 1fr">
      <UnauthorizedLayoutHeader />
      <Stack overflow="auto" height="100%" bgcolor="background.default">
        <Container maxWidth="md" sx={{ flex: 1, py: 2 }}>
          {children}
        </Container>
      </Stack>
    </Box>
  );
}
